import type { ToastMessageOptions } from 'primevue'
import { showToast } from './toast-instance'
import { useDesignVersion } from '../use-design-version'

const { isV2 } = useDesignVersion()

const toast = (content: string, options: ToastMessageOptions = {}) => {
    showToast({
        group: 'tl',
        summary: content,
        closable: true,
        severity: isV2.value ? 'secondary' : 'info',
        life: 3e3, // 3 seconds,
        ...options,
    })
}

const success = (content: string, options: ToastMessageOptions = {}) => {
    toast(content, { severity: 'success', styleClass: 'tl-toast--with-icon', ...options })
}

const error = (content: string, options: ToastMessageOptions = {}) => {
    toast(content, { severity: 'error', styleClass: 'tl-toast--with-icon', ...options })
}

const info = (content: string, options: ToastMessageOptions = {}) => {
    toast(content, { severity: 'info', ...options })
}

const warning = (content: string, options: ToastMessageOptions = {}) => {
    toast(content, { severity: 'warn', ...options })
}

const useNotification = () => ({
    success,
    error,
    warning,
    info,
    custom: toast,
})

export default useNotification
